import React from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import SingleTeamBanner from "./SingleTeamBanner";
import TeamDetailsAbout from "./TeamDetailsAbout";
import TeamDetailsHero from "./TeamDetailsHero";

const TeamDetails = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <SingleTeamBanner />
      <TeamDetailsHero />
      <TeamDetailsAbout />
      <FooterThree />
    </>
  );
};

export default TeamDetails;
